var _dec, _class;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Brick } from "zengular";
import twig from "./magic-input-checkboxes.twig";
import "./magic-input-checkboxes.scss";
import MagicInput from "./magic-input";
var MagicInputCheckboxesBrick = (_dec = Brick.register('magic-input-checkboxes', twig), _dec(_class = /*#__PURE__*/function (_MagicInput) {
  _inherits(MagicInputCheckboxesBrick, _MagicInput);

  var _super = _createSuper(MagicInputCheckboxesBrick);

  function MagicInputCheckboxesBrick() {
    _classCallCheck(this, MagicInputCheckboxesBrick);

    return _super.apply(this, arguments);
  }

  _createClass(MagicInputCheckboxesBrick, [{
    key: "readDataset",
    value: function readDataset() {
      var attributes = _get(_getPrototypeOf(MagicInputCheckboxesBrick.prototype), "readDataset", this).call(this);

      if (_typeof(attributes.options)) attributes.options = attributes.options.split(',').map(function (item) {
        return item.trim();
      });
      return attributes;
    }
  }, {
    key: "value",
    get: function get() {
      var checked = [];
      this.$$('input').nodes.forEach(function (input) {
        if (input.checked === true) checked.push(input.value);
      });
      return checked;
    },
    set: function set(value) {
      var _this = this;

      if (!Array.isArray(value)) value = [value];
      value.forEach(function (value) {
        _this.$$("input").filter('[value="' + value + '"]').each(function (item) {
          return item.checked = true;
        });
      });
    }
  }], [{
    key: "setAttributes",
    value: function setAttributes(options) {
      return {
        options: options
      };
    }
  }]);

  return MagicInputCheckboxesBrick;
}(MagicInput)) || _class);
export { MagicInputCheckboxesBrick as default };